import Swiper from "swiper/bundle";

/**
 * Stesse impostazioni del carosello clienti in crafto/demo-recruitment.html
 * (sezione clients-style-08, data-slider-options con slidesPerView 2, loop, autoplay delay 0, speed 6000, ecc.)
 */
function initLogosCarousel(root = document) {
    const swipers = root.querySelectorAll(".block-logos-carousel__swiper");

    swipers.forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        if (!el.querySelector(".swiper-slide")) {
            return;
        }

        const block = el.closest(".block-logos-carousel");
        const paginationEl = block?.querySelector(".block-logos-carousel__pagination");
        const nextEl = block?.querySelector(".block-logos-carousel__nav-next");
        const prevEl = block?.querySelector(".block-logos-carousel__nav-prev");

        /** @type {import("swiper").SwiperOptions} */
        const options = {
            slidesPerView: 2,
            slidesOffsetBefore: 16,
            spaceBetween: 0,
            speed: 6000,
            loop: true,
            effect: "slide",
            allowTouchMove: false,
            watchOverflow: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4
                },
                1200: {
                    slidesPerView: 5
                }
            }
        };

        if (paginationEl) {
            options.pagination = { el: paginationEl, clickable: false };
        }
        if (nextEl && prevEl) {
            options.navigation = { nextEl, prevEl };
        }

        new Swiper(el, options);
    });
}

export { initLogosCarousel };
